export * from "./ast/core/index.js";
export {
    NamingConfigSchema,
    NamingObjectSchema,
    TypescriptCustomConfigSchema
} from "./custom-config/TypescriptCustomConfigSchema.js";
export * as ts from "./typescript.js";
